<!--自动匹配库存-->
<template>
  <el-form ref="form" label-width="80px" size="mini">
    <div class="row-wrap" style="padding-left:30px;">
      <h4 style="padding-left:15px;">定时获取快递单号设置</h4>
      <el-row>
        <el-col :xs="24">
          <el-form-item :label="msg('是否开启自动获取快递单号：')" label-width="300">
            <!-- <el-radio v-model="autoSyncExpress" :label="1" @input="changeType(1)">是</el-radio>
            <el-radio v-model="autoSyncExpress" :label="0" @input="changeType(0)">否</el-radio> -->
            <el-switch v-model="autoSyncExpress" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭" @change="(val)=>changeSyncType(val)"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="msg('选择要执行的时间(可多选)：')" label-width="300">
            <el-checkbox v-model="checkedTime1" :disabled="autoSyncExpress==0">10:00:00</el-checkbox>
            <el-checkbox v-model="checkedTime2" :disabled="autoSyncExpress==0">14:00:00</el-checkbox>
            <el-checkbox v-model="checkedTime3" :disabled="autoSyncExpress==0">21:00:00</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{ msg('确定') }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingAutoSyncExpress",
  data() {
    return {
      xgroup: 'AUTO_SYNC_EXPRESS_GROUP',  //自动获取快递单号group
      autoSyncExpress: 0, // 是否自动获取快递单号
      checkedTime1: false, // 10:00:00
      checkedTime2: false, // 14:00:00
      checkedTime3: false, // 21:00:00
      storeId: null, // 仓库id
      stores: [], // 仓库列表
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      if (data.length > 0) {
        // this.needUpdateTransport = data[0].xvalue;
        // this.needUpdateTransportObj = data[0];
        let inv = JSON.parse(data[0].xvalue);
        this.autoSyncExpress = inv.autoSyncExpress;
        this.checkedTime1 = inv.checkedTime1;
        this.checkedTime2 = inv.checkedTime2;
        this.checkedTime3 = inv.checkedTime3;
      }
    },
    changeSyncType(val){
      if(val==0){
        this.checkedTime1 = false;
        this.checkedTime2 = false;
        this.checkedTime3 = false;
      }
    },
    update() {
      if(this.autoSyncExpress==1 && (!this.checkedTime1 && !this.checkedTime2 && !this.checkedTime3)){
        this.$message.error('请选择要执行的时间');
        return;
      }
      
      let datas = [];
      if (this.autoInventoryObj) {
        this.autoInventoryObj.xvalue = JSON.stringify({
            autoSyncExpress: this.autoSyncExpress,
          }),
        datas.push(this.autoInventoryObj);
      } else {
        this.autoInventoryObj = {
          id: null,
          xkey: this.xgroup,
          owner: null,
          xgroup: this.xgroup,
          xvalue: JSON.stringify({
            autoSyncExpress: this.autoSyncExpress,
            checkedTime1: this.checkedTime1,
            checkedTime2: this.checkedTime2,
            checkedTime3: this.checkedTime3,
          }),
          xtype: 0
        }
        datas.push(this.autoInventoryObj);
      }

      var _this = this;
      _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
        _this.$message(result.msg)
      });
    }
  }
}
</script>

<style scoped>

</style>